export const MODULES = {
    CreditNotes: 'CreditNotes',
};
